import React, {} from 'react';
import {connect} from "react-redux";
import {RESOURCE_ATTACHED_TO_TYPE, SIDEBAR_HIDDEN_BUTTONS} from "../../../../../../constants";
import SqftNavCustomBacksplashSection from "./SqftNavCustomBacksplashSection";
import {injectIntl} from "react-intl";

const SqftNavCustomBacksplashes = (props) => {
  const {intl, attachedToLine, activeSubMenuButton} = props;

  const backsplashes = attachedToLine.filter(attachedToLine => {
    return attachedToLine.type === RESOURCE_ATTACHED_TO_TYPE.backsplash
        && attachedToLine.name === intl.formatMessage({id: "sqft.navigation.submenu.customBacksplash"})
  });
  const expanded = (activeSubMenuButton === SIDEBAR_HIDDEN_BUTTONS.buttonCustomBacksplash) && backsplashes.length > 0;
  const sectionName = intl.formatMessage({id: "sqft.navigation.submenu.customBacksplash"});

  return (
    <div className={"content side-level2 side" + (expanded ? " expanded" : "")} >
      <div className="mitered-sections">
        {
          backsplashes.map((backsplash, index) => {
            if (!backsplash) {
              return
            }
            return <SqftNavCustomBacksplashSection sectionName={sectionName} backsplash={backsplash} index={index} key={index}/>
          })
        }
      </div>
    </div>
  )
};

const mapStateToProps = (store) => {
  return {
    attachedToLine: store.sqftResourceState.attachedToLine,
    menuOpened: store.sqftMenuState.menuOpened,
    miteredSections: store.sqftMiteredState.miteredSections,
    activeSubMenuButton: store.sqftMenuState.activeSubMenuButton,
  };
};

const mapDispatchToProps = {
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(SqftNavCustomBacksplashes)
);
